import { Component } from '@angular/core';

@Component({
    selector: 'app-form-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class FormErrorComponent {}
